import React from 'react';
import { Helmet } from 'react-helmet';
import Footer from '../../Shared/Footer/Footer';
import ContactUs from '../ContactUs/ContactUs';
import Header from '../Header/Header';
import OurProducts from '../OurProducts/OurProducts';
import OurServices from '../OurServices/OurServices';
import Testimonials from '../Testimonials/Testimonials';

const Home = () => {
    return (
        <div>
            <Helmet>
                <title>Home | Biotech</title>
            </Helmet>
            <Header />
            <OurServices />
            <OurProducts />
            <Testimonials />
            <ContactUs />
            <Footer />
        </div>
    )
}

export default Home;
